module.exports = __webpack_public_path__ + "static/media/24UHCHR22.b6809307.jpg";